import api from "./api";

export type LivePackage = {
  id: string;
  qty: number;
  price_cents: number;
  currency: string;
  active?: boolean;
  sort_order?: number;
};

export type BuyableAthlete = {
  athlete_id: string;
  name: string;
  is_self: boolean;
  lives: number;
  headroom: number;
};

export type LivesPurchaseConfig = {
  enabled: boolean;
  /**
   * Why the shop is off, when it is: "off" (platform switch), "no_packages"
   * (nobody has defined any life packages) or "stripe" (payments not
   * configured). Lets the screen say something actionable instead of a flat
   * "not available right now".
   */
  disabled_reason?: "off" | "no_packages" | "stripe" | null;
  hard_cap: number;
  packages: LivePackage[];
  athletes: BuyableAthlete[];
};

export type LivesPurchaseRow = {
  id: string;
  athlete_id: string;
  athlete_name: string;
  qty: number;
  amount_cents: number;
  currency: string;
  status: "pending" | "paid" | "failed" | "expired";
  created_at: string;
  paid_at: string | null;
  is_self: boolean;
};

export async function getLivesPurchaseConfig(): Promise<LivesPurchaseConfig> {
  const { data } = await api.get<LivesPurchaseConfig>("/lives-purchase/config");
  return data;
}

export async function createLivesCheckout(athleteId: string, packageId: string): Promise<{ url: string }> {
  const { data } = await api.post<{ url: string }>("/lives-purchase/checkout", {
    athlete_id: athleteId,
    package_id: packageId,
  });
  return data;
}

export async function getLivesPurchaseHistory(): Promise<LivesPurchaseRow[]> {
  const { data } = await api.get<LivesPurchaseRow[]>("/lives-purchase/history");
  return data;
}

// ---- Admin: package management ----

export async function getLifePackages(): Promise<LivePackage[]> {
  const { data } = await api.get<LivePackage[]>("/lives-purchase/packages");
  return data;
}

export async function createLifePackage(body: Partial<LivePackage>): Promise<LivePackage> {
  const { data } = await api.post<LivePackage>("/lives-purchase/packages", body);
  return data;
}

export async function updateLifePackage(id: string, body: Partial<LivePackage>): Promise<LivePackage> {
  const { data } = await api.patch<LivePackage>(`/lives-purchase/packages/${id}`, body);
  return data;
}

export async function deleteLifePackage(id: string): Promise<void> {
  await api.delete(`/lives-purchase/packages/${id}`);
}
